import type { BadgeMapEntry } from "@salestrak/ui";

// The one status → Badge map: the Status column, the team roster column, the
// Status group headers and the member profile chip all read it, so the three
// statuses look identical everywhere. In a table cell Active is `quiet` —
// plain muted text — because a roster is mostly active members and a column
// of identical chips says nothing N times; the exceptions wear the color.
// Where one chip names a whole band (group header, profile title) Active is
// blue rather than green, because green is the presence dot on the avatar in
// the same row — a green Active chip would read as "online". Invited is the
// pending wash. Suspended is the
// palette grey: a filled chip, so a parked account still registers as a
// state, on a mid-grey ink that stays quieter than the two live states. Not
// `secondary` — that wash IS the card surface in dark mode, so the chip
// disappeared there.
export const MEMBER_STATUS_BADGE: Record<string, BadgeMapEntry> = {
  active: { label: "Active", color: "info", quiet: true },
  invited: { label: "Invited", color: "warning" },
  suspended: { label: "Suspended", color: "grey" },
  // A member who removed themself wears the same parked grey: gone, not
  // pending, and their row stays for the work that names them.
  left: { label: "Left", color: "grey" },
};
